import { observer } from "mobx-react";
import { forwardRef, useImperativeHandle, useRef } from "react";
import LineChart from "./LineChart";
import MomentPointsChart from "./MomentPointsChart";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A line chart, where each data point is represented by a circle, and a line is
 * drawn between each point.
 */
export const _LineAndPointChart = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    chartItem,
    scales,
    color,
    glyph
  } = _ref;
  const lineRef = useRef(null);
  const pointRef = useRef(null);
  useImperativeHandle(ref, () => ({
    doZoom(scales) {
      var _lineRef$current, _pointRef$current;
      (_lineRef$current = lineRef.current) === null || _lineRef$current === void 0 || _lineRef$current.doZoom(scales);
      (_pointRef$current = pointRef.current) === null || _pointRef$current === void 0 || _pointRef$current.doZoom(scales);
    }
  }), []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LineChart, {
      ref: lineRef,
      chartItem: chartItem,
      scales: scales,
      color: color,
      id: id + "-line"
    }), /*#__PURE__*/_jsx(MomentPointsChart, {
      ref: pointRef,
      id: id + "-point",
      chartItem: chartItem,
      scales: scales,
      glyph: glyph
    })]
  });
});
_LineAndPointChart.displayName = "LineAndPointChart";
export default observer(_LineAndPointChart);